const parseGoal = rawGoal => ({
    schoolYear: Number(rawGoal.school_year),
    measure: rawGoal.measure,
    period: rawGoal.period,
    grade: rawGoal.grade_level,
    goalValue: rawGoal.goal_value,
});

export default parseGoal;
